import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import UseCitySubmit from "hooks/UseCityDistanceSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputAreaPrice from "components/form/InputAreaPrice";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import SelectTimePicker from "components/form/SelectTimePicker";

const CityDistanceDrawer = ({ id }) => {
  const {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    errors,
    loading,
    selectedFromCity,
    selectedToCity,
    setSelectedFromCity,
    setSelectedToCity,
    time,
    setTime,
  } = UseCitySubmit(id);

  const handleFormSubmit = (data) => {
    const formData = { ...data };

    onSubmit(formData);
  };

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title
          register={register}
          title={id ? "Edit City Distance" : "Add City Distance"}
        />
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                {/* State and City Name Inputs */}
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea label={"From City"} required />
                    <SelectSingleCityOnly
                      register={register}
                      label="From City"
                      name="from_city"
                      type="text"
                      placeholder={"--Choose--"}
                      selectedCity={selectedFromCity}
                      handleCityChange={setSelectedFromCity}
                    />
                    <Error errorName={errors.from_city} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="To City" required />
                    <SelectSingleCityOnly
                      register={register}
                      label="To City"
                      name="to_city"
                      type="text"
                      placeholder={"--Choose--"}
                      selectedCity={selectedToCity}
                      handleCityChange={setSelectedToCity}
                    />
                    <Error errorName={errors.to_city} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Km"} required />
                    <InputAreaPrice
                      register={register}
                      trigger={trigger}
                      label="KM"
                      type="number"
                      name="distance"
                      required={true}
                      maxLength={4}
                      placeholder={"KM"}
                    />
                    <Error errorName={errors.distance} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label={"Duration"} required />
                    <SelectTimePicker
                      register={register}
                      label="Duration"
                      name="duration"
                      required={true}
                      value={time}
                      onChangeFunction={(value) => setTime(value)}
                    />
                    <br />
                    <Error errorName={errors.duration} />
                  </div>
                </div>

                {/* Notify Error if Submit Disabled */}
              </div>
              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Edit" : "Save"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default CityDistanceDrawer;
